<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="360px">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>Send {{ isEmail? 'Email': 'SMS' }}</span>
        </div>
        <div class="dialog-body">
          <el-form
            ref="send-form"
            :rules="rules"
            :model="sendFormData">
            <div
              v-if="allSelect"
              class="form-item">
              <el-form-item
                ref="send_type"
                prop="send_type"
                :rules="rules.select">
                <v-radio-group
                  v-model="sendFormData.send_type"
                  :list="sendList"
                />
              </el-form-item>

            </div>
            <div
              v-if="isRenew"
              class="flex flex-align-center color-dark fs-14 mg-b-16">
              <span class="fw-600">Auto renew : {{autoRenew?'ON':'OFF'}}</span> <span
                v-if="autoRenew"
                class="color-dark fs-14 mg-l-5">(Debit Date {{autoPayAt}})</span>
            </div>
            <template v-if="(type==1||type==2&&hasSendEmail)&&isFina||type!=2&&isFina||isOnlyReferrer">
              <div class="form-item">
                <span class="mg-l-28">Referrer</span>
                <el-form-item >
                  <div class="flex-align-center">
                    <v-checkbox
                      v-if="!isOnlyReferrer"
                      v-model="sendFormData.referrer_send"
                      :is-boolean="false"
                      class="mg-r-15"></v-checkbox>
                    <v-input
                      :value="referSendValue"
                      disabled
                    />
                  </div>
                </el-form-item>

              </div>
              <div class="form-item">
                <el-form-item
                  prop="referrer_content"
                  :rules="rules.input">
                  <v-input
                    v-model="sendFormData.referrer_content"
                    :disabled="sendFormData.referrer_send==0&&!isOnlyReferrer"
                    type="textarea"
                    :rows="4" />
                </el-form-item>
              </div>
            </template>
            <template v-if="!isOnlyReferrer">
              <div class="form-item">
                <span>Customer</span>
                <!--            <div>-->
                <!--              <span>{{ !isEmail?currentName+'-':'' }} {{ currentContact }}</span>-->
                <!--            </div>-->
                <el-form-item >
                  <div class="flex-align-center">
                    <v-checkbox
                      v-if="isFina"
                      v-model="sendFormData.customer_send"
                      :is-boolean="false"
                      class="mg-r-15"></v-checkbox>
                    <v-input
                      :value="allSelect?sendContact:`${ !isEmail?currentName+' - ':''} ${currentContact}`"
                      disabled
                    />
                  </div>
                </el-form-item>
              </div>
              <div
                v-if="isEmail && !!emailListTitle"
                class="form-item">
                <span>Email list title</span>
                <div>
                  <span>{{emailListTitle}}</span>
                </div>
              </div>
              <div
                v-if="isEmail && !!emailTitle"
                class="form-item">
                <span>Title</span>
                <div>
                  <span>{{emailTitle}}</span>
                </div>
              </div>
              <div class="form-item">
                <span>Content</span>
                <el-form-item prop="content">
                  <v-input
                    v-model="sendFormData.content"
                    type="textarea"
                    :disabled="isFina?sendFormData.customer_send==0:false"
                    :rows="4" />
                </el-form-item>
              </div>
              <div
                v-if="lastContent"
                class="form-item">
                <span>Last Content</span>
                <el-form-item prop="content">
                  <v-input
                    :value="lastContent"
                    type="textarea"
                    disabled
                    :rows="4" />
                </el-form-item>
              </div>
            </template>
          </el-form>
          <div class="flex-sb-center">
            <div>
              <v-button
                gray
                @click="onCancel">Cancel</v-button>
            </div>
            <div>
              <v-button
                v-if="skip"
                gray
                @click="onSkip">Skip</v-button>
              <v-button
                green
                :disabled="isFina&&(!sendFormData.referrer_send&&!sendFormData.customer_send)&&!isOnlyReferrer"
                @click="onSend">Send</v-button>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'

export default {
  name: 'SendEmailSmsDialog',
  mixins: [MixinRules,MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    initContent: {
      type: String,
      default: ''
    },
    initReferContent: {
      type: String,
      default: ''
    },
    lastContent: {
      type: String,
      default: ''
    },
    skip: {
      type: Boolean,
      default: true
    },
    showUsername:{
      type: Boolean,
      default: false
    },
    isEdit:{
      type: Boolean,
      default: false
    },
    isFina:{
      type: Boolean,
      default: false
    },
    isRenew:{
      type: Boolean,
      default: false
    },
    autoRenew:{
      type: Boolean,
      default: false
    },
    autoPayAt:{
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 0
    },
    updateContent: {
      type: Boolean,
      default: false
    },
    allSelect: {
      type: Boolean,
      default: false
    },
    emailListTitle: {
      type: String,
      default: ''
    },
    emailTitle: {
      type: String,
      default: ''
    },
    isOnlyReferrer:{
      type: Boolean,
      default: false
    },
    isAccountReferrer:{
      type: Boolean,
      default: false
    },
    isTicket:{
      type: Boolean,
      default: false
    },
    value:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      sendFormData: {
        content: '',
        referrer_content: '',
        send_type:'',
        customer_send:0,
        referrer_send:0,
      }
    }
  },
  computed: {
    referrer(){
      let {referrer,referral_info} = this.form||{}
      if(this.isTicket)
        return referral_info||{}
      return referrer||{}
    },
    referSendValue(){
      let {isrd_nm,send_mobile,send_email,identity,phone} = this.referrer||{}
      if(this.isAccountReferrer||this.isOnlyReferrer&&JSON.stringify(this.referrer) == '{}'){
        let {
          contact_phone,
          mobile_no,
          phone,
          email,
          draft_email,
          phone_no} = this.form
        let per_phone = mobile_no||phone||phone_no
        let send_email = email
        let contact =`${this.isPersonal?per_phone:(this.isAccountReferrer?send_email:contact_phone)}`
        return  this.currentName?`${this.currentName} - ${contact}`:contact
      }
      if(this.isTicket){
        return `${isrd_nm} - ${phone}`
      }
      return `${isrd_nm} - ${this.type!=2?send_mobile:send_email}`
    },
    hasSendEmail(){
      let {isrd_nm,send_mobile,send_email} = this.referrer||{}
      return !!send_email
    },
    isEmail() {
      if(this.type == 0) {
        return !this.isPersonal
      }
      if(this.type == 2) {
        return true
      }
      return false
    },
    isPersonal() {
      const { identity, cust_typ } = this.form||{}
      if(identity && identity == 1) {
        return true
      }
      if(cust_typ && cust_typ == 1) {
        return true
      }
      return false
    },
    currentName() {
      const { isrd_lst_nm, isrd_fst_nm, contact_nm, isrd_nm } = this.form||{}
      let name = ''
      if(isrd_nm){
        name = isrd_nm
      }else{
        name =  `${isrd_lst_nm} ${isrd_fst_nm}`
      }
      return this.isPersonal?name:contact_nm
    },
    sendContact(){
      let {send_type} = this.sendFormData||{}
      const {
        mobile_no,
        contact_email,
        phone,
        email,
        contact_phone,
        draft_email,
        phone_no } = this.form||{}
      let send_phone = contact_phone||mobile_no || phone || phone_no

      if(send_type==3) {
        return this.currentName?`${this.currentName} - ${send_phone},${email}`:`${send_phone},${email}`
      }
      if(send_type==2)
        return  this.currentName?`${this.currentName} - ${email}`:email
      return  this.currentName?`${this.currentName} - ${send_phone}`:send_phone

    },
    currentContact() {
      const {
        mobile_no,
        contact_email,
        phone,
        email,
        user_name,
        contact_phone,
        phone_no } = this.form||{}
      if(this.showUsername)
        return user_name
      if(this.isPersonal) {
        if(this.isEmail) {
          return email
        }
        // account detail customer_profile 這裏用的 phone
        return contact_phone||mobile_no || phone || phone_no
      }

      if(!this.isEmail) {
        return contact_phone
      }
      if(this.isEdit&&!this.isPersonal)
        return  email
      return contact_email||email
    }
  },
  watch: {
    initContent: {
      immediate: true,
      handler(val, old) {
        if(val != old && (!this.sendFormData.content || this.updateContent)) {
          this.sendFormData.content = val
          this.sendFormData.referrer_content = val
        }
      }
    },
    initReferContent: {
      immediate: true,
      handler(val, old) {
        this.sendFormData.referrer_content = val
      }
    },
    dialog: {
      //   immediate: false,
      handler(val) {
        if(!val) {
          this.$emit('close')
        }else{
          this.formData = this.form
        }
      }
    },
    value:{
      immediate:true,
      handler(val){
        this.dialog = val
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
      this.$emit('input',this.dialog)
    },
    onCancel() {
      this.$emit('cancel')
      this.dialog = false
      this.$emit('input',this.dialog)
    },
    onSend() {
      this.$refs['send-form'].validate((valid, rules) => {
        if(valid) {
          this.dialog = false
          this.$emit('input',false)
          let {send_type,content} = this.sendFormData||{}
          if(!this.isFina)
            this.sendFormData.customer_send =1
          this.$emit('send', content,send_type,this.sendFormData)
        }
        else {
          console.log(rules)
        }
      })
    },
    onSkip() {
      this.dialog = false
      this.$emit('input',false)
      this.$emit('skip')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
}
.dialog-container {

  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #1B1F23;
    }
  }
  .dialog-body{
    padding: 20px 15px;
  }
      h3 {
        padding-bottom: 10px;
      }
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
      .form-item {
          & > span {
              font-weight: 600;
              font-size: 14px;
          }
      }
    }
</style>
